export const BRAND = {
  name: "ORO JEWELS",
  tagline: "Da noi i tuoi gioielli valgono di più",
};

export const CONTACTS = {
  email: "info@orook.it",
  instagram: "https://www.instagram.com/orojewels.porpora",
  instagramHandle: "@orojewels.porpora",
  whatsappNumber: "390222228579",
};

export const waLink = (text) =>
  `https://wa.me/${CONTACTS.whatsappNumber}?text=${encodeURIComponent(text)}`;

export const STORES = [
  {
    id: "porpora",
    city: "Milano",
    name: "Milano Porpora",
    address: "Via Nicola Antonio Porpora, 156",
    zip: "20131 Milano",
    phone: "02 22228579",
    tel: "+390222228579",
    hours: ["Mar – Sab: 9:30 – 19:00 (orario continuato)", "Dom e Lun: chiuso"],
    map: "https://www.google.com/maps/search/?api=1&query=Via+Nicola+Antonio+Porpora+156+Milano",
  },
  {
    id: "murat",
    city: "Milano",
    name: "Milano Murat",
    address: "Via Gioacchino Murat, 60",
    zip: "20159 Milano",
    phone: "02 49480395",
    tel: "+390249480395",
    hours: ["Lun, Mar, Mer, Ven, Sab: 10:00 – 19:30 (orario continuato)", "Gio e Dom: chiuso"],
    map: "https://www.google.com/maps/search/?api=1&query=Via+Gioacchino+Murat+60+Milano",
  },
  {
    id: "monza",
    city: "Monza",
    name: "Monza Viale Libertà",
    address: "Viale Libertà, 29",
    zip: "20900 Monza",
    phone: "039 9157715",
    tel: "+390399157715",
    hours: ["Lun – Gio: 10:00 – 19:00 (orario continuato)", "Ven: 10:00 – 13:00", "Sab e Dom: chiuso"],
    map: "https://www.google.com/maps/search/?api=1&query=Viale+Libert%C3%A0+29+Monza",
  },
];

export const CATEGORIES = [
  { slug: "anelli", label: "Anelli" },
  { slug: "orecchini", label: "Orecchini" },
  { slug: "bracciali", label: "Bracciali" },
  { slug: "collane", label: "Collane" },
  { slug: "ciondoli", label: "Ciondoli" },
  { slug: "orologi", label: "Orologi" },
];

export const CATEGORY_LABELS = Object.fromEntries(CATEGORIES.map((c) => [c.slug, c.label]));

export const REVIEWS = [
  {
    author: "Claudia Pezzoni",
    text: "Garanzia di estrema professionalità, modi cortesi e chiarezza nella valutazione per poter effettuare la propria scelta.",
  },
  {
    author: "Alessandra Castagnedi",
    text: "Tra tutti i compro oro che ho girato, questo è l'unico che ha valutato in modo onesto e professionale il mio prodotto. Molto professionale e molto chiaro.",
  },
  {
    author: "Maria Di Stefano",
    text: "Gentilissimo, disponibile e molto competente. Mi sono trovata benissimo.",
  },
  {
    author: "Vincenzo Russo",
    text: "Mi sto servendo qui da qualche mese ed è proprio perché mi sono sempre trovato benissimo per professionalità, disponibilità e cortesia.",
  },
];

export const fmtPrice = (n) =>
  n != null ? n.toLocaleString("it-IT", { maximumFractionDigits: 0 }) : "";
